import '../../monitoring/filters/applied_numeric_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.AppliedNumericView extends Monitoring.Views.SocialContents.Filters.AppliedNumericView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
